module.exports = __webpack_public_path__ + "61c3f0d3c352d33fa4a0e8de5a03f3a7.png";